import _ from 'lodash';

export default function isFullEmptyObject(obj: object): boolean {
  return Object.keys(_.omitBy(obj, (v) => !v)).length === 0;
}
